export enum subscriptionSources {
  HEADER = 'header',
  FOOTER = 'footer',
  ONLINE_CHECK_IN = 'online_check_in',
  PAYMENT_PAGE = 'payment_page'
}
